import { components } from 'react-select';
import { Avatar, Box, Flex, Icon, Tooltip } from '@chakra-ui/react';
import { PiCalendarXDuotone, PiSmileySadDuotone } from 'react-icons/pi';
import { KText } from '@/ui-library/components';
import { SCHEDULE_AI_COPY } from '../../constants';

export const SchAiInterviewerMultiValueLabel = ({
  children,
  data,
  ...props
}: any) => {
  const isCalendarDisconnected = data?.calendar_available === false;

  return (
    <components.MultiValueLabel {...props}>
      <Flex alignItems="center" gap="4px">
        {isCalendarDisconnected && (
          <Tooltip
            placement="top"
            bg="#FFF"
            borderRadius="6px"
            boxShadow="0px 18px 18px rgba(215, 218, 235, 0.09), 0px 4px 10px rgba(215, 218, 235, 0.1)"
            shouldWrapChildren
            label={
              <Flex align="center" gap="6px" p="8px">
                <Icon
                  as={PiSmileySadDuotone as unknown as React.ElementType}
                  w="18px"
                  h="18px"
                  color="secondary-700"
                />
                <KText fontSize="xs" color="secondary-900">
                  {SCHEDULE_AI_COPY.calendarNotConnectedTooltip}
                </KText>
              </Flex>
            }
          >
            <Icon
              as={PiCalendarXDuotone as unknown as React.ElementType}
              w="14px"
              h="14px"
              color="secondary-700"
              onClick={(e) => e.stopPropagation()}
            />
          </Tooltip>
        )}
        <Avatar
          className="avatar-xs"
          name={data?.name}
          width="20px"
          height="20px"
          src={data?.avatar}
        />
        <Box as="span" display="inline-block" ml="sm">
          {children}
        </Box>
      </Flex>
    </components.MultiValueLabel>
  );
};
